// L'événement "30min" n'existe pas sur cal.leman-it.com (404 constaté le
// 2026-10-01) : le site pointe sur "discovery-call" dans les deux langues.
export const CAL_LINK = "tcb/discovery-call";
export const CAL_NAMESPACE = "lemanit-booking";

export function getCalLink(_lang: string): string {
  return CAL_LINK;
}
